<template>
  <div class="mobile-history-info">
    <div v-if="sessionHistories && sessionHistories.length > 0"
         style="overflow: auto; height: 100%;">
      <div @click="handleDetail(item)" class="item" :class="item.active ? 'active': ''"
           v-for="(item, index) in sessionHistories">
        <div v-show="!item.showEdit" style="width: 100%;">
          <div class="overflow-hidden" style="width: 80%;" :title="item.title">{{ item.title }}</div>
        </div>
        <div v-show="!item.showEdit && item.active" class="edit-button">
          <span @click="handleOpenInput($event, item, index)" class="el-icon-edit-outline"></span>
          <span @click="handleDeletedSession($event, item, index)" class="el-icon-delete"></span>
        </div>
        <div style="width: 100%;" v-show="item.showEdit && item.active">
          <div @click.stop>
            <el-input :ref="'editMobileSession_' + index" size="mini" v-model="item.title"
                      @change="handleEditSessionTitle(item)"
                      @blur="handleCloseInput(item)"></el-input>
          </div>
        </div>
      </div>
    </div>
    <div style="height: calc(100% - 26px);display: flex; align-items: center; justify-content: center;" v-else>
      <el-empty />
    </div>
  </div>
</template>

<script>
  import SessionApi from '@/api/session';

  export default {
    name: "MobileHistorySession",
    components: {},
    props: {
      sessionHistoryList: {
        type: Array,
        default: []
      },
    },
    data() {
      return {
        showEdit: false,
        sessionHistories: [],
        messageList: [],
        showChatVisible: false,
      }
    },
    watch: {
      sessionHistoryList: {
        immediate: true,
        handler(newValue, oldValue) {
          this.sessionHistories = newValue;
        }
      },
    },
    methods: {
      handleDetail(val) {
        if (!val.active) {
          this.$router.push({
            name: 'history',
            params: {
              sessionId: val.id,
            },
          });
        }
        this.$emit('getHistory', val.id);
      },
      cancelChatDialog() {
        this.messageList = [];
        this.showChatVisible = false;
      },
      handleDeletedSession(event, val, index) {
        event.stopPropagation();
        const that = this;
        that.$confirm("是否删除该会话?", {
          customClass: 'my-confirm',
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          that.axios.get(SessionApi.delete, {params: {sessionId: val.id}}).then(res => {
            that.sessionHistories.splice(index, 1);
          });
        }).catch(() => {
        });
      },
      handleOpenInput(event, val, index) {
        event.stopPropagation();
        val.showEdit = true;
        setTimeout(() => {
          this.$refs[`editMobileSession_${index}`][0].focus();
        }, 0);
      },
      handleCloseInput(val) {
        val.showEdit = false;
      },
      handleEditSessionTitle(val) {
        const that = this;
        val.showEdit = false;
        const query = Object.assign({
          id: val.id,
          title: val.title,
        });
        that.axios.post(SessionApi.edit, query).then(res => {

        });
      },
    },
  }
</script>

<style lang="scss">
  .my-confirm {
    width: 300px!important;
  }
  .el-message-box__wrapper {
    z-index: 7779!important;
  }
  .el-overlay{
    z-index: 9999!important;
  }
</style>

<style scoped lang="scss">
  .overflow-hidden {
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    word-break: break-all;
  }

  .mobile-history-info {
    height: 100%;
    ::v-deep .el-empty__image {
      width: 100px;
    }
    .active {
      background-color: #CFDDFF;
    }
    .item {
      position: relative;
      border-radius: 8px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0.5rem;
      cursor: pointer;

      .edit-button {
        position: absolute;
        right: 0;
        display: block;

        span {
          opacity: 1;
          margin: 0 3px;

          &:hover {
            color: red;
          }
        }
      }
    }
  }
</style>
